import styled from 'styled-components';
import { FaSpinner } from 'react-icons/fa';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 300px;
`;

export const SyncButton = styled.button`
    width: 100%;
    height: 45px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    border: 0;
    border-radius: 4px;

    background: #28a745;
    color: #fff;

    font-size: 14px;
    font-weight: 500;

    cursor: pointer;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const GearIconContainer = styled.span`
    display: flex;
    align-items: center;
`;

export const SpinnerIcon = styled(FaSpinner)`
    animation: spin 1s linear infinite;

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;